import { action, createRequestTypes } from 'utils/actions'

export const SETUPFORM_ADD_NEW_VOUCHER = "SETUPFORM_ADD_NEW_VOUCHER"
export const SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API = createRequestTypes('SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API')
export const SETUPFORM_EDIT_VOUCHER = "SETUPFORM_EDIT_VOUCHER"
export const SETUPFORM_START_COPYING_VOUCHER = "SETUPFORM_START_COPYING_VOUCHER"
export const SETUPFORM_START_DELETING_VOUCHER = "SETUPFORM_START_DELETING_VOUCHER"
export const SETUPFORM_VOUCHER_DELETED = "SETUPFORM_VOUCHER_DELETED"


export const bulkUpdateSetupformInstanceGroups = {
  request: () => action(SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API.REQUEST),
  success: response => action(SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API.SUCCESS, { response }),
  failure: error => action(SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API.FAILURE, { error }),
}

export const addNewVoucher = (setupformId, values) =>
  action(SETUPFORM_ADD_NEW_VOUCHER, { setupformId, values })

export const editVoucher = (setupformId, instanceGroupId, values) =>
  action(SETUPFORM_EDIT_VOUCHER, { setupformId, instanceGroupId, values })

export const startCopyingVoucher = (setupformId, instanceGroupId) =>
  action(SETUPFORM_START_COPYING_VOUCHER, { setupformId, instanceGroupId })

export const startDeletingVoucher = (setupformId, instanceGroupId) =>
  action(SETUPFORM_START_DELETING_VOUCHER, { setupformId, instanceGroupId })



/** WEBPACK FOOTER **
 ** ./src/actions/setupform-voucher/setupform-voucher-actions.js
 **/